import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./components/App";
import Nav from "./components/nav/Nav";
import Footer from "./components/Footer";

ReactDOM.render(
  <React.StrictMode>
    <Nav />
    <App />
    <Footer />
  </React.StrictMode>,
  document.getElementById("root"),
);
